import React from 'react';
import classnames from 'classnames';
import { Text, Icon, IconProps } from '../index';

import styles from './toast.module.scss';

type VariantType = 'informational' | 'success' | 'warning' | 'error' | 'none';

export type ToastProps = {
  content: { headline?: string; text?: string };
  variant?: VariantType;
  'aria-hidden'?: boolean;
  className?: string;
};

const chooseIcon = (variant: 'informational' | 'success' | 'warning' | 'error'): IconProps['name'] => {
  switch (variant) {
    case 'informational':
      return 'info-legal--small';
    case 'success':
      return 'successful-checkmark--small';
    case 'warning':
      return 'warning--small';
    case 'error':
      return 'alert--small';
  }
};

export const Toast: React.FC<ToastProps> = ({ className, content, variant, 'aria-hidden': ariaHidden }) => {
  const classes = classnames(styles.toast, className, 'setting--inverted');

  return (
    <output className={classes} aria-hidden={ariaHidden} data-testid="toast-component">
      {variant && variant !== 'none' && <div className={classnames(styles.signal, styles[variant])} />}
      <div className={styles.content}>
        {variant && variant !== 'none' && <Icon name={chooseIcon(variant)} className={styles.icon} />}
        <div className={styles.textContent}>
          {content.headline && (
            <Text className={styles.headline} variant="label-200">
              {content.headline}
            </Text>
          )}
          {content.text && <Text variant="caption-300">{content.text}</Text>}
        </div>
      </div>
    </output>
  );
};
